import { baseToCustomUOM, getMeasurementUnits } from 'helpers/unitHelper';
import { actionTypes, advancedAnalyticsButtons } from './constants';
import { getInitialEndDate, getInitialStartDate } from 'sharedComponents/TimeSelectorRow/helpers';
import { MEASUREMENT_UNIT_GROUP } from './RegreasingAdvice/constants';

const initialState = {
    activeTab: advancedAnalyticsButtons.annualMaintenancePlan,
    annualMaintenancePlan: {
        data: null,
        error: null,
        loadingStatus: null,
        errorCode: null
    },
    dailyAgingStress: {
        data: null,
        error: null,
        errorCode: null,
        loadingStatus: null,
        dateSelection: {
            from: getInitialStartDate(30),
            to: getInitialEndDate()
        }
    },
    lubricationData: {
        data: null,
        error: null,
        loadingStatus: null
    },
    lubricationMaintenanceInfo: {
        data: null,
        error: null,
        loadingStatus: null
    },
    currentLubricationMaintenanceInfo: {
        data: null,
        error: null,
        loadingStatus: null,
        isModified: false
    }
};

const convertReferenceTemperature = (temperature, precision = 1) => {
    const userMeasurementUnitGroups = getMeasurementUnits();
    const convertedTemperature = +baseToCustomUOM.convertWithGroups(MEASUREMENT_UNIT_GROUP, temperature, userMeasurementUnitGroups);
    const convertedTemperatureWithPrecision = Number.isInteger(convertedTemperature) ? convertedTemperature : +convertedTemperature?.toFixed(precision);
    return convertedTemperatureWithPrecision;
};

const handleLubricationMaintenanceInfo = (state, action) => {
    // Add isLast: true to the last record in action.data.history (if present)
    const convertedTemperatureWithPrecision = convertReferenceTemperature(action?.data?.referenceTemperature, action.data?.referenceTemperaturePrecision);
    const enhancedAction = (() => {
        const data = action?.data;
        if (data && Array.isArray(data?.history) && data?.history?.length > 0) {
            const history = data?.history?.map((rec, idx, arr) =>
                idx === arr.length - 1 ? { ...rec, isLast: true } : { ...rec }
            );
            return { ...action, data: { ...data, history } };
        }
        return action;
    })();

    return {
        ...state,
        lubricationMaintenanceInfo: {
            ...state.lubricationMaintenanceInfo,
            ...enhancedAction,
            data: {
                ...action.data,
                referenceTemperature: convertedTemperatureWithPrecision
            }
        },
        currentLubricationMaintenanceInfo: {
            isModified: false,
            ...enhancedAction,
            data: {
                ...action.data,
                referenceTemperature: convertedTemperatureWithPrecision
            },
        }
    };
};

const currentLubricationMaintenanceInfoUpdate = (state, action) => {
    return {
        ...state,
        currentLubricationMaintenanceInfo: {
            ...state.currentLubricationMaintenanceInfo,
            ...action,
            isModified: true
        }
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ACTIVE_TAB:
            return {
                ...state,
                activeTab: action.activeTab
            };
        case actionTypes.GET_ANNUAL_MAINTENANCE_PLAN:
            return {
                ...state,
                annualMaintenancePlan: {
                    ...action,
                    error: action?.error?.message || null,
                    errorCode: action?.error?.statusCode || null
                }
            };
        case actionTypes.GET_DAILY_AGING_STRESS:
            return {
                ...state,
                dailyAgingStress: {
                    ...state.dailyAgingStress,
                    ...action
                }
            };
        case actionTypes.SET_DATE_SELECTION:
            return {
                ...state,
                dailyAgingStress: {
                    ...state.dailyAgingStress,
                    dateSelection: {
                        ...action.dateSelection
                    }
                }
            };

        case actionTypes.GET_LUBRICATION_RECOMMENDATION_DATA: {
            const convertedTemperatureWithPrecision = convertReferenceTemperature(action.data?.lubricationConfiguration?.referenceTemperature, action.data?.lubricationConfiguration?.referenceTemperaturePrecision);
            return {
                ...state,
                lubricationData: {
                    ...action,
                    data: {
                        ...action.data,
                        lubricationConfiguration: {
                            ...action.data?.lubricationConfiguration,
                            referenceTemperature: convertedTemperatureWithPrecision || action.data?.lubricationConfiguration?.referenceTemperature
                        }
                    }
                }
            };
        }

        case actionTypes.GET_LUBRICATION_MAINTENANCE_INFO:
            return handleLubricationMaintenanceInfo(state, action);

        case actionTypes.UPDATE_CURRENT_LUBRICATION_MAINTENANCE_INFO:
            return currentLubricationMaintenanceInfoUpdate(state, action);

        case actionTypes.UPDATE_LUBRICATION_MAINTENANCE_INFO:
            return handleLubricationMaintenanceInfo(state, action);

        case actionTypes.CLEAR_STORE: {
            return {
                ...state,
                annualMaintenancePlan: initialState.annualMaintenancePlan,
                dailyAgingStress: {
                    ...initialState.dailyAgingStress,
                    dateSelection: {
                        ...state.dailyAgingStress.dateSelection
                    }
                },
                lubricationData: {
                    ...initialState.lubricationData
                },
                lubricationMaintenanceInfo: {
                    ...initialState.lubricationMaintenanceInfo
                },
                currentLubricationMaintenanceInfo: {
                    ...initialState.currentLubricationMaintenanceInfo
                }
            };
        }
        default:
            return state;
    }
};
